module.exports = __webpack_public_path__ + "media/images/suppliers/finetest-b78086e8b50103f9ca7b4048a89652b9.png";